import NotificationsContainer from '../../routes/Notifications/container/NotificationsContainer'

// Sync route definition
export default {
  path: '/notifications/:gatewayId',
  component : NotificationsContainer,
}
